import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'idtTrustHtml',
})
export class IdtTrustHtmlPipe implements PipeTransform {
    constructor(private readonly sanitizer: DomSanitizer) {}

    public transform(htmlString: Record<string, unknown> | string): any {
        const value = typeof htmlString === 'string' ? htmlString : JSON.stringify(htmlString);
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}
